import React, { useState } from "react";
import {
  Box,
  Button,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import {
  MainTabPanel,
  StyledTab,
  StyledTabs,
  a11yProps,
} from "../Common/UI/TabPanel";
import StudyTab from "./StudyTab";
import { useSearchParams } from "react-router-dom";
import { HeaderRightContent, StyledHeader } from "../Common/styles/header";
import SurveyPackage from "../SurveyPackage/SurveyPackage";
import { useAppSelector } from "../../Redux/hooks";
import { permissions } from "../../utils/roles";
import ExportAllModal from "./ExportAllModal";
import ExportDataDictionaryModal from "./ExportDataDictionaryModal";
import ConfirmStudyLiveModal from "../StudySettings/Modals/ConfirmStudyLiveModal";
import { featuresMap } from "../../utils/features";
import ImportDataDictionaryModal from "../StudySettings/Modals/DataDictionaryModal";
import Screening from "./Screening";
import { KeyboardArrowDown } from "@mui/icons-material";
// import TimeLine from "./Timeline";

const getDefault = (features: any, param: string) => {
  // if (param === "timeline") {
  //   if (features?.[featuresMap.timeline]) {
  //     return param;
  //   }
  // }
  if (param === "screening") {
    if (features?.[featuresMap.visit]) {
      return param;
    }
  }
  if (param === "visit") {
    if (features?.[featuresMap.visit]) {
      return param;
    }
  } else if (param === "repeatingData") {
    if (features?.[featuresMap.repeatedData]) {
      return param;
    }
  } else if (param === "surveys") {
    if (features?.[featuresMap.survey]) {
      return param;
    }
  } else if (param === "surveyPackage") {
    if (features?.[featuresMap.survey]) {
      return param;
    }
  }

  // return features?.[featuresMap.timeline]
  //   ? "timeline"
  //   :
  return features?.[featuresMap.visit]
    ? "screening"
    : features?.[featuresMap.repeatedData]
    ? "repeatingData"
    : features?.[featuresMap.survey]
    ? "surveys"
    : "";
};
const StudyDesigner = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const features = useAppSelector((state) => state.study.features);
  const studyPermissions = useAppSelector(
    (state) => state.study.studyPermissions
  );
  const status = useAppSelector((state) => state.study.status);
  const languages = useAppSelector((state) => state.study.languages);

  const [anchorEl, setAnchorEl] = useState<any>(null);
  const open = Boolean(anchorEl);

  const [canEdit] = useState(
    status === "not_live" &&
      studyPermissions.includes(permissions.studyDesigner)
  );
  const [canStudyMakeLive] = useState(
    status === "not_live" &&
      studyPermissions.includes(permissions.studySettings)
  );
  const [canExport] = useState(studyPermissions.includes(permissions.export));
  const type =
    getDefault(features, searchParams.get("type") ?? "screening") ||
    "screening";
  const [showModal, setShowModal] = useState<string>("");

  const phasesMap: any = {
    visit: {
      val: "visit",
      headerLabel: "Visit",
      buttonLabel: "Add Visit",
    },
    repeatingData: {
      val: "repeated_data",
      headerLabel: "Repeating Data",
      buttonLabel: "Add Repeating Data",
    },
    surveys: {
      val: "survey",
      headerLabel: "Surveys",
      buttonLabel: "Add Surveys",
    },
    surveyPackage: {
      val: "surveyPackage",
      headerLabel: "Survey Package",
      buttonLabel: "Add Survey Package",
    },
    screening: {
      val: "screening",
      headerLabel: "Screening",
      buttonLabel: "Add New",
    },
    // timeline: {
    //   val: "timeline",
    //   headerLabel: "TimeLine",
    //   buttonLabel: `Edit Timeline`,
    // },
  };

  const handleChange = (_1: any, val: string) => {
    const params = new URLSearchParams(searchParams);
    params.set("type", val);
    setSearchParams(params, { replace: true });
  };
  const closeModal = () => {
    setShowModal("");
  };

  return (
    <>
      <StyledHeader>
        <Typography variant="h2" color="text.primary">
          Study Designer
        </Typography>
        <Box sx={HeaderRightContent}>
          {/* {canEdit && (
            <Button
              variant="contained"
              onClick={() => setShowModal("import_data_dictionary")}
            >
              Import Data Dictionary
            </Button>
          )} */}
          {canStudyMakeLive && (
            <Button variant="outlined" onClick={() => setShowModal("go_live")}>
              Go Live
            </Button>
          )}
          {/* <Button
            variant="outlined"
            endIcon={<KeyboardArrowDown />}
            onClick={(e) => setAnchorEl(e?.currentTarget)}
          >
            Actions
          </Button> */}
        </Box>
      </StyledHeader>
      <Box
        sx={{
          borderTop: 1,
          borderColor: "#E5E7EB",
          borderBottom: "1px solid #E5E7EB",
        }}
      >
        <StyledTabs value={type} onChange={handleChange}>
          {/*
          {features?.[featuresMap.timeline] && (
            <StyledTab label={"Timeline"} value="timeline" {...a11yProps(4)} />
          )}
 */}
          {features?.[featuresMap.visit] && (
            <StyledTab
              label={"Screening"}
              value="screening"
              {...a11yProps(4)}
            />
          )}
          {features?.[featuresMap.visit] && (
            <StyledTab label={"Visit"} value="visit" {...a11yProps(0)} />
          )}
          {features?.[featuresMap.repeatedData] && (
            <StyledTab
              label={"Repeating Data"}
              value="repeatingData"
              {...a11yProps(1)}
            />
          )}
          {features?.[featuresMap.survey] && (
            <StyledTab label={"Survey"} value="surveys" {...a11yProps(2)} />
          )}
          {features?.[featuresMap.survey] && (
            <StyledTab
              label={"Survey Package"}
              value="surveyPackage"
              {...a11yProps(3)}
            />
          )}
        </StyledTabs>
      </Box>
      <Box sx={{ height: "calc(100vh - 186px)", overflow: "hidden" }}>
        <MainTabPanel value={type} index={type}>
          {phasesMap[type]?.val === "surveyPackage" ? (
            <SurveyPackage type={phasesMap[type]} canEdit={canEdit} />
          ) : // ) : phasesMap[type]?.val === "timeline" ? (
          //   <TimeLine canEdit={canEdit} />
          // )
          phasesMap[type]?.val === "screening" ? (
            <Screening
              canEdit={canEdit}
              canExport={canExport}
              languages={languages}
              type="study"
            />
          ) : phasesMap[type]?.val ? (
            <StudyTab
              type={phasesMap[type]}
              canEdit={canEdit}
              canExport={canExport}
            />
          ) : null}
        </MainTabPanel>
      </Box>
      {showModal === "export_all" && (
        <ExportAllModal
          showModal={showModal === "export_all"}
          closeModal={closeModal}
        />
      )}
      {showModal === "export_data_dictionary" && (
        <ExportDataDictionaryModal
          showModal={showModal === "export_data_dictionary"}
          closeModal={closeModal}
        />
      )}
      {showModal === "import_data_dictionary" && (
        <ImportDataDictionaryModal
          showModal={showModal === "import_data_dictionary"}
          closeModal={closeModal}
        />
      )}
      {showModal === "go_live" && (
        <ConfirmStudyLiveModal
          showModal={showModal === "go_live"}
          closeModal={closeModal}
        />
      )}
      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        {canExport && (
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              setShowModal("export_all");
            }}
          >
            <ListItemText> Export Data</ListItemText>
          </MenuItem>
        )}
        {/* {canExport && (
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              setShowModal("export_data_dictionary");
            }}
          >
            <ListItemText> Export Data Dictionary</ListItemText>
          </MenuItem>
        )} */}
      </Menu>
    </>
  );
};

export default StudyDesigner;
